import { convertChannelCasing } from 'lib-shared-api-utils';
import { ConversationsChannels } from 'lib-shared-legacy-types';

import { channelAttributes } from 'utils/channels';

export function getChannelName(channel: ConversationsChannels): string {
  return (
    channelAttributes[convertChannelCasing(channel, 'snake')]?.name ??
    'Unknown Channel'
  );
}
